import { blockCategories } from '../../categories';

export default (editor) => {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    blockManager.add('container').set({
        label: 'Sprachumschalter',
        category: blockCategories.advance,
        content: {
            type: 'language-switcher',
            classes: ['language-switcher'],
        },
        media: `
          <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#e3e3e3">
          <path d="m476-80 182-480h84L924-80h-84l-43-122H603L560-80h-84ZM160-200l-56-56 202-202q-35-35-63.5-80T190-640h84q20 39 40 68t48 58q33-33 68.5-92.5T484-720H40v-80h280v-80h80v80h280v80H564q-21 72-63 148t-83 116l96 98-30 82-122-125-202 201Zm468-72h144l-72-204-72 204Z"/>
          </svg>
        `,
    });

    const defaultType = domComponents.getType('default');
    const defaultModel = defaultType.model;
    const defaultView = defaultType.view;

    domComponents.addType('language-switcher', {
        model: {
            defaults: Object.assign({}, defaultModel.prototype.defaults, {
                'custom-name': 'Sprachumschalter',
                tagName: 'div',
                droppable: true,
                components: 'DE &#9662;',
                style: {
                    border: '2px solid #e5e7eb',
                    margin: '20px 0',
                    padding: '10px',
                    'border-radius': '10px',
                    'font-weight': 'bold',
                },
            }),
        },
        isComponent(el) {
            if (
                el &&
                el.classList &&
                el.classList.contains('language-switcher')
            ) {
                return { type: 'language-switcher' };
            }
        },
        view: defaultView,
    });
};
